import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SelectCropPage.css';

const crops = ['Wheat', 'Rice', 'Maize', 'Banana', 'Sugarcane', 'Potato'];

function SelectCropPage() {
  const navigate = useNavigate();

  const handleCropClick = (crop) => {
    navigate(`/history/${crop}`);
  };

  return (
    <div className="select-crop-page">
      <h2 id='heading' style={{color:"black"}}>Select the crop which you want to plant</h2>
      <div className="scrollable-container">
        <div className="scrollable-content">
          <ul className="crop-list">
            {crops.map((crop, index) => (
              <li key={index}>
                <button className="crop-button" onClick={() => handleCropClick(crop)}>
                  {crop}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SelectCropPage;
